<div>
    <div class="wizard-header row">
        <div class="col-12 page-title">
            {{'specialOffers.title' | translate}}
        </div>
    </div>

    <div class="wizard-container">
        <button
            class="btn link-btn btn-back-txt"
            (click)="redirectToSpecialOffersList()">
            <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
            <span>
                {{("specialOffers.wizard.navSpecialOffersList" | translate)}}
            </span>
        </button>

        <div class="wizard-main-content">
            <ng-container>
                <div class="request-sent-container wizard-item">
                    <span class="request-sent-title">{{'specialOffers.wizard.campaignPublished.title' |
                        translate}}</span>
                    <span class="request-sent-subtitle">
                        <span>{{'specialOffers.wizard.campaignPublished.subtitle1' | translate}}</span>
                        <span
                            class="text-primary fw-bold cursor-pointer"
                            (click)="redirectToSpecialOffersList()">
                            {{'specialOffers.wizard.campaignPublished.subtitle2' | translate}}
                        </span>
                        <span>{{'specialOffers.wizard.campaignPublished.subtitle3' | translate}}</span>
                    </span>
                    <request-sent-placeholder class="mt-5"></request-sent-placeholder>
                </div>
            </ng-container>
        </div>
    </div>
</div>